import { useCompletionInbox } from "@/entities/notification/completion-inbox.hooks"
import { useTranslation } from "react-i18next"

export function QualityEvaluationBadge() {
  const entries = useCompletionInbox()
  const { t } = useTranslation()
  if (!entries.some((entry) => entry.kind !== "cat-review" && !entry.isRead))
    return null
  return (
    <span
      role="img"
      aria-label={t("notification.unreadQualityEvaluation")}
      className="inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-key-color"
      data-testid="quality-evaluation-unread-dot"
    />
  )
}
